<template>
  <section id="wrapper">
    <header>
      <div class="inner">
        <h2>{{ album.name }}</h2>
        <p>{{ album.description }}</p>
      </div>
    </header>
    <div class="wrapper">
      <div class="inner">
        <section class="album">
          <h3 class="major">{{ album.name }}</h3>
          <div class="box alt">
            <div class="row gtr-uniform">
              <div
                class="col-4 col-12-small"
                v-for="image in album.images"
                :key="image.id"
              >
                <span class="image fit">
                  <img :src="image.url" alt="" />
                </span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useHead } from '@unhead/vue';

import { api } from '../api/client';
import type { AlbumDetail } from '../types';

useHead({ title: 'Album' });

const route = useRoute();
const router = useRouter();

const album = ref<Partial<AlbumDetail>>({});

if (!route.params.id) {
  router.push({ name: 'gallery' });
} else {
  api.getAlbum(route.params.id as string, (response) => {
    album.value = response.data.data;
  });
}
</script>
